const styles = (theme) => ({
  /** Input Button */
  selectedTag: {
    color: theme.palette.white.main,
    textShadow: `1px 1px 1px ${theme.palette.black.main}20`,
    fontSize: "14px",
    height: "22px",
  },
  inputTag: {
    "& .MuiInputBase-input": {
      padding: "2px 6px", // padding interno reduzido
      fontSize: "0.75rem", // fonte do input
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.95rem", // fonte da label
    },
  },
  inputPlaceHolder: { ml: "-4px" },
  inputContainer: { position: "relative", width: "100%" },
  inputLabel: {
    position: "absolute",
    top: "-8px",
    left: "12px",
    fontSize: "16px",
    backgroundColor: "transparent",
    px: 1,
    color: theme.palette.text.secondary,
    zIndex: 1,
    pointerEvents: "none",
  },
  linearProgress: {
    position: "absolute",
    width: "100%",
    top: 0,
    zIndex: 1,
  },
  inputButton: {
    justifyContent: "flex-start",
    textAlign: "left",
    textTransform: "none",
    borderColor: "colors.gray.medium",
    "&:hover": { borderColor: "colors.black.darker" },
  },
  /** Lista de Tags */
  tagListMenu: {
    "& .MuiPaper-root": {
      width: 300,
      maxHeight: 400,
    },
  },
  tagListContainer: { p: 1 },
  tagListItem: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  filteredList: { maxHeight: 300, overflowY: "auto", mt: 1 },
  filteredItem: { display: "flex", justifyContent: "space-between" },
  createItem: { fontStyle: "italic" },
  /** Menu de ações */
  actionMenuAnchorOrigin: {
    vertical: "center",
    horizontal: "right",
  },
  actionMenuTransformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  /** Modal Delete */
  deleteModalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 2,
    borderRadius: 2,
    minWidth: 300,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  deleteModalButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 1,
  },
  /** Modal Edit */
  editModalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    p: 2,
    borderRadius: 2,
    minWidth: 300,
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  editModalColorBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    flexDirection: "row",
  },
  editModalSelectedColor: {
    width: "20px",
    height: 16,
    border: "1px solid #999",
    borderRadius: 1,
  },
  editModalColorOption: {
    width: "20px",
    height: 16,
    minHeight: 20,
    border: "1px solid #999",
    borderRadius: "4px",
  },
  editModalButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 1,
  },
});

export default styles;
